


// Development

// export const firebaseConfig = {
//   apiKey: "AIzaSyCnmOb9yb7cFQxK3lX0qe3fmBIG0vPrTmM",
//   authDomain: "efa-lms-development.firebaseapp.com",
//   databaseURL: "https://efa-lms-development.firebaseio.com",
//   projectId: "efa-lms-development",
//   storageBucket: "efa-lms-development.appspot.com",
//   messagingSenderId: "65851539259"
// };





// FIREBASE ENVIRONMEWNT SELECTION
// firebase use
// firebase use development
// firebase use production





// Production

export const firebaseConfig = {
  apiKey: 'AIzaSyAnby8pRGKCAKXWmVkUdQBe5n5FBlwBwX8',
  authDomain: 'efa-lms-e8982.firebaseapp.com',
  databaseURL: 'https://efa-lms-e8982.firebaseio.com',
  projectId: 'efa-lms-e8982',
  storageBucket: 'efa-lms-e8982.appspot.com',
  messagingSenderId: '165781516525'
};
